/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from 'react'
import intl from 'react-intl-universal'
import { animated, Spring } from 'react-spring/renderprops.cjs'
import FeaturedMediaCardHeader from './featuredMediaCardHeader.sfc'
import { ICardItemSFC } from './types'

const CONTAINER_HEIGHT = 165
const CONTAINER_COLLAPSED_HEIGHT = 12

const getTransition = (collapsed) => ({
  height: collapsed ? CONTAINER_COLLAPSED_HEIGHT : CONTAINER_HEIGHT,
})

// eslint-disable-next-line react/display-name
const renderContent = (props: ICardItemSFC) => (style) => (
  <animated.div style={{ ...style, overflow: 'hidden' }}>
    <form>
      <div className="form-group">
        <strong className="text-muted">
          {intl.get('settings.featuredMedia.mediaTypes')}
        </strong>
        <p className=".text-dark">
          {props.card.value.types.map(({ label }) => label).join(', ')}
        </p>
        <strong className="text-muted">
          {intl.get('settings.featuredMedia.mediaKey')}
        </strong>
        <p className=".text-dark">{props.card.key}</p>
      </div>
      <div className="form-group form-check">
        <input
          type="checkbox"
          className="form-check-input"
          id={`publish-require-for-${props.card.key}`}
          checked={props.card.value.requiredToPublish}
          onChange={props.toggleRequired}
          aria-checked={props.card.value.requiredToPublish}
        />
        <label htmlFor={`publish-require-for-${props.card.key}`}>
          {intl.get('settings.featuredMedia.requirePublish')}
        </label>
      </div>
    </form>
  </animated.div>
)

const CardItemSFC = (props: ICardItemSFC) => (
  <div className="pt-2">
    <div className="card bg-light text-black featured-media-card-item">
      <div className="container">
        <FeaturedMediaCardHeader
          label={props.card.value.label}
          toggleCollapsed={props.toggleCollapsed}
          remove={props.remove}
          collapsed={props.collapsed}
        />
        <Spring
          native={true}
          from={getTransition(false)}
          to={getTransition(props.collapsed)}
        >
          {renderContent(props)}
        </Spring>
      </div>
    </div>
  </div>
)

export default CardItemSFC
